import React from 'react';
import {
    Typography
} from '@mui/material'
import styled from 'styled-components'

const Container = styled.div`
    padding: 1em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const Header = ({ pageTitle, button }) => {

    return (
        <Container>
            <Typography variant="h6">{pageTitle}</Typography>
            {button}
        </Container>
    )
};

export { Header };
